module.exports = __webpack_public_path__ + "img/4229f96.svg";